import Reveal from "@/components/home/Reveal";
import { BadgePercent, Bot, Users, MapPin } from "lucide-react";

const ITEMS = [
  { icon: BadgePercent, title: "0% de comisión, para siempre", text: "Cada peso que factures se queda en tu caja. No cobramos por pedido, ni ahora ni en 5 años." },
  { icon: Bot, title: "Tu menú digital lo hace la IA", text: "Súbenos una foto de tu menú impreso. Nuestra IA lo procesa y te lo deja listo en minutos." },
  { icon: Users, title: "El cliente es tuyo, no de una app", text: "Los datos, el WhatsApp y la relación de tu comensal se quedan contigo. Sin intermediarios que te escondan a tu propio cliente." },
  { icon: MapPin, title: "Aparece en Google Maps automáticamente", text: "Sincronizamos tu menú con tu Google Business Profile. Cuando alguien te busque, ve tu menú al instante." },
];

export const Benefits = () => (
  <section id="beneficios" className="mt-section bg-white" data-testid="benefits-section">
    <div className="mt-container">
      <Reveal className="max-w-2xl">
        <p className="text-brand-orange font-semibold text-sm uppercase tracking-wider">Por qué MenuThere</p>
        <h2 className="mt-2 text-3xl sm:text-4xl lg:text-5xl leading-tight">Deja de regalar el <span className="text-brand-orange">34.8%</span> de cada pedido.</h2>
        <p className="mt-4 text-base md:text-lg text-gray-600">
          MenuThere no compite con Rappi, Uber Eats o DiDi Food: compite contra su comisión del 30-35%. El 96% de los 750,000+ restaurantes en México son microempresas que ceden hasta 30% de su margen a plataformas de delivery.
        </p>
      </Reveal>
      <div className="mt-12 grid sm:grid-cols-2 gap-5 lg:gap-6">
        {ITEMS.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={i * 90} className="group rounded-3xl border border-orange-100 bg-brand-cream/60 p-7 lg:p-9 hover:bg-white hover:shadow-[0_18px_50px_rgba(255,102,18,0.14)] hover:-translate-y-1 transition-all duration-300" data-testid={`benefit-card-${i + 1}`}>
            <div className="w-14 h-14 rounded-2xl bg-brand-orange text-white grid place-items-center shadow-[0_8px_22px_rgba(255,102,18,0.35)] group-hover:scale-110 transition-transform">
              <Icon className="w-7 h-7" />
            </div>
            <h3 className="mt-6 text-xl lg:text-2xl leading-snug">{title}</h3>
            <p className="mt-3 text-gray-600 leading-relaxed">{text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Benefits;
